export default __webpack_public_path__ + "static/media/infoCircleIcon.638f2d56.svg";